<mat-form-field appearance="outline" class="select-with-footer-field">
  <mat-select
    #selectRef
    [formControl]="control"
    [multiple]="multiple"
    [placeholder]="placeholder"
    [panelClass]="panelClass"
    [disableOptionCentering]="disableOptionCentering"
    [compareWith]="resolvedCompareWith"
    [ngClass]="selectClass"
    (openedChange)="onOpenedChange($event)"
  >
    <mat-option
      *ngFor="let option of options"
      [value]="getOptionValue(option)"
      [disabled]="isOptionDisabled(option)"
      [matTooltip]="getOptionTooltip(option)"
      [matTooltipDisabled]="!getOptionTooltip(option)"
    >
      {{ getOptionLabel(option) }}
    </mat-option>

    <mat-option class="no-checkbox sticky-option" disabled *ngIf="showFooter">
      <div class="option-footer">
        <button
          mat-stroked-button
          class="dropdown-button"
          [ngClass]="{ 'dropdown-ok-button': hasSelection() }"
          (click)="close(selectRef, $event)"
        >
          <ng-container *ngIf="hasSelection(); else closeLabelTemplate">
            <span>{{ okLabel }}</span>
          </ng-container>

          <ng-template #closeLabelTemplate>
            <span>{{ closeLabel }}</span>
          </ng-template>
        </button>
      </div>
    </mat-option>
  </mat-select>

  <mat-error *ngIf="showError && errorMessage">{{ errorMessage }}</mat-error>
</mat-form-field>